/**
 * 产品详情页 slug 到 contact_us_key 的唯一映射来源。
 */
export const PRODUCT_CONTACT_US_KEY_MAP: Record<string, string> = {
  bellabotpro: 'bellabotpro',
  'flashbot-new': 'flashbot-new',
  'cc1-pro': 'cc1-pro',
  d9: 'pudud9',
  pudud9: 'pudud9',
  sh: 'sh',
  mt1: 'mt1',
  pudut300: 'pudut300',
}

/**
 * 根据产品页 slug（或已有 robot 值）解析联系表单使用的 robot 参数值。
 * @param productSlugOrRobot 产品 slug 或已存在的 robot 参数值
 * @returns 解析后的 robot 参数值；当输入为空时返回 undefined
 */
export function resolveContactUsRobot(productSlugOrRobot?: string): string | undefined {
  if (!productSlugOrRobot) return undefined
  return PRODUCT_CONTACT_US_KEY_MAP[productSlugOrRobot] ?? productSlugOrRobot
}

/**
 * 构建联系页链接，保留 `robot` 参数名。
 * @param productSlugOrRobot 产品 slug 或已存在的 robot 参数值
 * @returns 联系页 URL；无参数时返回 `/contact-us`
 */
export function buildContactUsHref(productSlugOrRobot?: string): string {
  const robot = resolveContactUsRobot(productSlugOrRobot)
  if (!robot) return '/contact-us'
  return `/contact-us?robot=${encodeURIComponent(robot)}`
}
